import { render, staticRenderFns } from "./AuditoriaActionRenderer.vue?vue&type=template&id=5b1bcac2"
import script from "./AuditoriaActionRenderer.vue?vue&type=script&lang=js"
export * from "./AuditoriaActionRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports